import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { useViewer } from '@/features/session';
import { DISCONNECT_CLAUDE_CODE } from '@/graphql/mutations/connections';

type UseDisconnectClaudeCodeResult = {
  disconnectClaudeCode: () => Promise<void>;
  isDisconnecting: boolean;
};

export function useDisconnectClaudeCode(): UseDisconnectClaudeCodeResult {
  const { refreshViewer } = useViewer();
  const [mutate, { loading }] = useMutation(DISCONNECT_CLAUDE_CODE);

  const disconnectClaudeCode = useCallback(async () => {
    await mutate();
    await refreshViewer();
  }, [mutate, refreshViewer]);

  return { disconnectClaudeCode, isDisconnecting: loading };
}
